import { saveAs } from 'file-saver'
import { downloadStatisticsZip } from '@/services/download-api'


export async function exportFile(dataCard, internalPivotConfig, tableData) {
  const indicatorId = dataCard?.data?.[0]?.id
  const title = dataCard?.data?.[0]?.title || 'export'
  const dateData = new Date().toISOString().replace(/\.\d{3}Z$/, 'Z')

  const config = {
    indicatorId,
    language: window?.store?.state?.i18n?.lang,
    fileNameDownload: 'customExport.csv',
    pivotConfig: internalPivotConfig,
    tableData,
    dateData,
  }

  const resp = await downloadStatisticsZip(config)
  const zipBlob = resp?.data
  
  if (!zipBlob) return

  saveAs(zipBlob, `Taula estadistica - ${title}.zip`)
}
